// extracted by mini-css-extract-plugin
export default {"imguser":"sidebar_imguser__LMUZt","sidebar":"sidebar_sidebar__e6PpP","cpointer":"sidebar_cpointer__AdFBv"};